var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-region-label"},[_c('p',[_vm._v("Ваш город")]),_vm._v(" "),_c('region-label')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }